import ServiceBase from './serviceBase';
import { Topic, TopicsContainer } from './types/Toolkit';

class ToolkitService extends ServiceBase {
  getToolkit = async (type: string, operationId: number): Promise<TopicsContainer> =>
    this.get<TopicsContainer>(`toolkit/${type}/operation/${operationId}`);

  getToolkitForId = async (id: number): Promise<TopicsContainer> =>
    this.get<TopicsContainer>(`toolkit/${id}`);

  getTopics = async (type = 'Classic'): Promise<Topic[]> =>
    this.get<Topic[]>(`toolkit/topics/${type}`);
}

const toolkitService = new ToolkitService();

export default toolkitService;
